import CommonResourcesEn from "./CommonResources.En";

export default {
  ...CommonResourcesEn,
  title: "<b>Log in</b> and benefit from goodie cashback",
  codeDescription: "Invitation code: ",
  formTitle: "Log in",
  formTitleModal: "<b>Login</b> to goodie",
  formButton: "Log in via {ProviderName}",
  socialButtonsTitle: "or log in how you like",
  changeScreenButtonText: "You haven't an account already?",
  changeScreenButtonLink: "Sign up",
};
